// these are relics from an older layout
// other pages are built to support a drawer, so leaving for now
export const DRAWER_WIDTH = 320;
export const DRAWER_WIDTH_CLOSED = 70;
